var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui-game-sidebar" }, [
    _c(
      "div",
      { staticClass: "new-game-sidebar__bet-creator" },
      [
        !_vm.isLg
          ? _c("div", { staticClass: "new-game-sidebar__head" }, [
              _c("div", { staticClass: "new-game-sidebar__title" }, [
                _c("span", { staticClass: "icon", class: _vm.icon }),
                _c("span", [_vm._v(_vm._s(_vm.modeName))]),
              ]),
              _vm.subtitle
                ? _c("div", { staticClass: "new-game-sidebar__subtitle" }, [
                    _vm._v(" " + _vm._s(_vm.subtitle) + " "),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "new-game-sidebar__head-actions" }, [
                _vm.howItWorksSlides && !_vm.settingsState.streamerMode
                  ? _c("span", {
                      staticClass:
                        "new-game-sidebar__info icon icon_info-instruction",
                      on: { click: _vm.openHowGameWorksDialog },
                    })
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "bet-creator" }, [
          _c(
            "div",
            { staticClass: "bet-creator__content" },
            [
              _vm._t("betContent"),
              _vm.currentBetType === _vm.BetType.BALANCE || _vm.balanceOnly
                ? _c("manual-bet", {
                    attrs: {
                      styling: _vm.gameMode,
                      fastAmounts: _vm.fastAmounts,
                      "bet-type": _vm.BetType.BALANCE,
                      "bet-amount-usd": _vm.internalBetAmount,
                      userBalanceUsd: _vm.userBalanceUsd,
                      "min-bet-enabled": _vm.minBetEnabled,
                    },
                    on: { "update:betAmountUsd": _vm.handleAmountUpdate },
                  })
                : _vm.currentBetType === _vm.BetType.INVENTORY &&
                  !_vm.balanceOnly
                ? _c(
                    "div",
                    { staticClass: "bet-creator__inventory" },
                    [_c("items-inventory")],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "bet-creator__wrapper" },
                [
                  _vm._t("createBetButton"),
                  _vm.autobetsEnabled
                    ? _c("bets-autobet-button", {
                        attrs: {
                          mode: _vm.gameMode,
                          disabled: !_vm.isAuthenticated,
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
            ],
            2
          ),
        ]),
        _vm._t("userBets"),
      ],
      2
    ),
    _vm.hasFairGame
      ? _c("div", { staticClass: "new-game-sidebar__footer" }, [
          _c("div", {
            staticClass: "new-game-sidebar__shield icon icon_shield-bold",
          }),
          _c("div", { staticClass: "new-game-sidebar__round" }, [
            _c("div", { staticClass: "new-game-sidebar__round-title" }, [
              _vm._v("ROUND"),
            ]),
            _vm.roundId
              ? _c("div", { staticClass: "new-game-sidebar__round-number" }, [
                  _vm._v(" #" + _vm._s(_vm.roundId) + " "),
                ])
              : _c("div", {
                  attrs: {
                    background: "rgba(102, 208, 138, 0.4)",
                    width: "3.4375rem",
                    height: "1em",
                  },
                }),
          ]),
          _vm.roundHash
            ? _c("div", { staticClass: "new-game-sidebar__hash" }, [
                _vm._v(" " + _vm._s(_vm.formatHash(_vm.roundHash)) + " "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn_icon button_copy",
                    attrs: { type: "button", "aria-label": "copy round hash" },
                    on: { click: _vm.copyRoundHash },
                  },
                  [_c("span", { staticClass: "icon icon_copy-bold-alt" })]
                ),
              ])
            : _c("div", { staticClass: "new-game-sidebar__hash" }, [_vm._m(0)]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn btn_icon button_copy",
        attrs: { type: "button", "aria-label": "copy", disabled: "" },
      },
      [_c("span", { staticClass: "icon icon_copy-bold-alt" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }